<!-- eslint-disable vue/require-v-for-key -->
<template>
  <ol class="breadcrumb">
    <li v-for="(item, index) in list" class="breadcrumb-item">
      <span v-if="isLast(index)" class="active">{{ uniTranslation(showName(item)) }}</span>
      <router-link v-else :to="item">{{ uniTranslation(showName(item)) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast(index) {
      return index === this.list.length - 1;
    },
    showName(item) {
      if (item.meta && item.meta.label) {
        return item.meta && item.meta.label;
      }
      if (item.name) {
        return item.name;
      }
      return item;
    }
  }
};
</script>
